import { useEffect, useRef } from "react";

export default function useLatestEffect(callback, deps, delay = 500) {
  const timerRef = useRef(null);

  useEffect(() => {
    let clearFn;
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      clearFn = callback();
    }, delay);

    return () => {
      clearTimeout(timerRef.current);
      clearFn?.();
    };
  }, deps);
}
